import { useMutation, useQueryCache } from 'react-query';
import { EventCategoryAPI } from 'api/admin/eventCategory';
import { EVENT_CATEGORIES } from 'helpers/constants';
import dispatchToast from 'helpers/dispatchToast';

export default function useUpdateEventCategory() {
  const queryCache = useQueryCache();

  return useMutation(EventCategoryAPI.update, {
    onSuccess: ({ message }, { onSuccess = () => {} }) => {
      queryCache.invalidateQueries(EVENT_CATEGORIES);
      dispatchToast({ message, type: 'success' });
      onSuccess();
    },
  });
}
